module.exports = __webpack_public_path__ + "img/nodata.de7f40f4.svg";